
// client only, NavigateStore
export enum DetailPageType {
	DASHBOARD = "DASHBOARD",
	PROJECT = "PROJECT",
	STUDENT = "STUDENT"
};
